<ng-template
    #block
    let-label="label"
    let-last="last"
    let-number="number"
>
    <div class="d-block">
        <div class="datetime-counter__block d-flex mb-2">
            <div
                *ngFor="let element of number;let last = last;"
                [ngClass]="{'mr-1': !last}"
                class="datetime-counter__element headline-5 px-2 py-1"
            >{{element}}</div>
        </div>
        <div class="datetime-counter__label d-flex align-items-center justify-content-center caption">{{label}}</div>
    </div>
    <div *ngIf="!last" class="datetime-counter__separator d-flex align-items-center headline-5 mx-2">:</div>
</ng-template>

<ng-template
    #block2
    let-label="label"
    let-last="last"
    let-number="number"
>
    <div class="d-flex mx-2">
        <div class="datetime-counter__block d-flex mb-2">
            <div
                *ngFor="let element of number;let last = last;"
                [ngClass]="{'mr-1': !last}"
                class="datetime-counter__element headline-5 px-2 py-1"
            >{{element}}</div>
        </div>
        <div class="datetime-counter__label d-flex align-items-center justify-content-center caption ml-1">{{label}}</div>
    </div>
</ng-template>

<ng-container *ngIf="auctionControlMethod === 1 || autoCloseEnabled === true">
    <ng-container *ngIf="mode === 1">
        <div class="d-flex flex-column align-items-center"  *ngIf="isStartingIn">
            <div class="datetime-counter__title--green subtitle-2 mb-2 mx-2">Auction Opens</div>
            <div class="datetime-counter d-flex justify-content-center">
                <ng-container *ngIf="mode === 1">
                    <ng-container *ngFor="let segment of startingIn; let last = last;">
                        <ng-container
                            [ngTemplateOutlet]="getTemplateOutlet()"
                            [ngTemplateOutletContext]="getTemplateOutletContex(segment, last)"
                        ></ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    
        <div class="d-flex align-items-center"  *ngIf="isEndsIn">
            <div class="datetime-counter__title--red subtitle-2 mb-2 mx-2">Auction Ends</div>
            <div class="datetime-counter d-flex justify-content-center">
                <ng-container *ngIf="mode === 1">
                    <ng-container *ngFor="let segment of endsIn; let last = last;">
                        <ng-container
                            [ngTemplateOutlet]="getTemplateOutlet()"
                            [ngTemplateOutletContext]="getTemplateOutletContex(segment, last)"
                        ></ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="mode === 2">
        <div class="auction__info d-flex align-items-center justify-content-center mb-2 px-3 pt-3 text-left" *ngIf="isStartingIn">
            <div class="event__settings event__settings--green pb-3">
                <div class="icon__wrapper d-inline-flex align-items-center mr-2">
                    <i class="far fa-clock"></i>
                </div>
                Auction starts {{startingInFormat}}
            </div>
        </div>

        <div class="auction__info d-flex align-items-center justify-content-center mb-2 px-3 pt-3 text-left" *ngIf="isEndsIn">
            <div class="event__settings event__settings--green pb-3">
                <div class="icon__wrapper d-inline-flex align-items-center mr-2">
                    <i class="far fa-clock"></i>
                </div>
                Auction ends {{endsInFormat}}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="mode === 3">
        <div class="auction__info d-flex align-items-center justify-content-end mb-2" *ngIf="isStartingIn && auctionControlMethod === 1">
            <div class="body-2">
              <span class="grey-text" [ngClass]="customStyles ? customStyles : ''">Bidding Starts in </span><b>{{startingInFormat}}</b>
            </div>
        </div>

        <div class="auction__info d-flex align-items-center justify-content-end mb-2" *ngIf="isEndsIn && auctionControlMethod === 1">
            <div class="body-2">
                <span class="grey-text" [ngClass]="customStyles ? customStyles : ''">Bidding Ends in </span><b>{{endsInFormat}}</b>
            </div>
        </div>

        <div class="auction__info d-flex align-items-center justify-content-end mb-2" *ngIf="isClosingIn && autoCloseEnabled === true">
            <div class="body-2">
                <span class="grey-text" [ngClass]="customStyles ? customStyles : ''">Auction Closes in </span><b>{{closingInFormat}}</b>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="mode === 4">
        <div class="auction__info d-flex align-items-center justify-content-end mb-2" *ngIf="isStartingIn && auctionControlMethod === 1">
            <div class="body-2">
              <span class="grey-text" [ngClass]="customStyles ? customStyles : ''">Bidding Starts in </span><b>{{startingInFormat}}</b>
            </div>
        </div>

        <div class="auction__info d-flex align-items-center justify-content-end mb-2" *ngIf="isEndsIn && auctionControlMethod === 1">
            <div class="body-2">
                <span class="grey-text" [ngClass]="customStyles ? customStyles : ''">Bidding Ends in </span><b>{{endsInFormat}}</b>
            </div>
        </div>
    </ng-container>

    @if(mode === 5) {
        <div class="d-flex justify-content-center align-items-center">
            <i class="far fa-clock mr-2"></i>
            <div class="body-1 text-center">Auction starts {{startingInFormat}}</div>
        </div>
    }
</ng-container>
